export default "__VITE_ASSET__B7SX8Eu0__"